import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F4F4F4\" d=\"M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32-14.327 32-32 32S0 49.673 0 32\"></path><path fill=\"#CACACA\" d=\"M64 55.984v8.019H0v-7.99a39.94 39.94 0 0 1 32.01-16.01c13.078 0 24.694 6.277 31.99 15.981M42.672 24a10.667 10.667 0 1 1-21.333 0 10.667 10.667 0 0 1 21.333 0\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32-14.327 32-32 32S0 49.673 0 32\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }